import { render, staticRenderFns } from "./addShortSelect.vue?vue&type=template&id=224f8ff6&scoped=true&"
import script from "./addShortSelect.vue?vue&type=script&lang=js&"
export * from "./addShortSelect.vue?vue&type=script&lang=js&"
import style0 from "./addShortSelect.vue?vue&type=style&index=0&id=224f8ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f8ff6",
  null
  
)

export default component.exports